export default {"src":"/_next/static/media/case.6728e77e.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};